import { GroupMembers, GroupTabs } from 'features/Group'
import { User } from 'features/User'
import dynamic from 'next/dynamic'
import { logger } from 'utils'

const BatchLeaderTab = dynamic(
  () => import('../components/Tabs/BatchLeaderTab')
)
const GroupDetailTab = dynamic(
  () => import('../components/Tabs/GroupDetailTab')
)
const GroupFeedbackTab = dynamic(
  () => import('../components/Tabs/GroupFeedbackTab')
)
const ReportIssueFeedbackTab = dynamic(
  () => import('../components/Tabs/ReportIssueFeedbackTab')
)
const ScrumsTab = dynamic(() => import('../components/Tabs/ScrumsTab'))

export const getGroupTabs = (
  user: User,
  groupMembers: GroupMembers,
  isBatchLeader: boolean
) => {
  const tabs: GroupTabs = {
    home: {
      key: 'home',
      label: 'Home',
      component: GroupDetailTab
    }
  }

  const groupMemberTabs: GroupTabs = {
    scrums: {
      key: 'scrums',
      label: 'Scrums',
      component: ScrumsTab
    },
    group_feedback: {
      key: 'group_feedback',
      label: 'Group Feedback',
      component: GroupFeedbackTab
    },
    issue_feedback: {
      key: 'issue_feedback',
      label: 'Report an Issue',
      component: ReportIssueFeedbackTab
    }
  }

  const adminTabs: GroupTabs = {
    batch_leader: {
      key: 'batch_leader',
      label: 'Batch Leader',
      component: BatchLeaderTab
    }
  }

  const isUserPartOfGroup = groupMembers.find(
    (member) => member.user_id === user.id
  )

  if (user.type === 'admin' || isBatchLeader) {
    logger('getGroupTabs', user, isUserPartOfGroup)
    return { ...tabs, ...groupMemberTabs, ...adminTabs }
  }

  if (isUserPartOfGroup) {
    logger('getGroupTabs', user, isUserPartOfGroup)
    return { ...tabs, ...groupMemberTabs }
  }

  return tabs
}
